export function getIndustries() {
  return [
    { value: 'furniture', label: 'Furniture' },
    { value: 'appliances', label: 'Appliances' },
    { value: 'mattress', label: 'Mattress' },
    { value: 'furniture_appliances', label: 'Furniture & Appliances' },
    { value: 'distribution', label: 'Distribution' },
    { value: 'construction', label: 'Construction Work & Materials' },
    { value: 'pharmaceutical', label: 'Pharmaceutical Products' },
    { value: 'servicing', label: 'Servicing & Maintenance' },
    { value: 'transport', label: 'General Transport' },
    { value: 'grocery_produce', label: 'Grocery & Produce' },
    { value: 'meals_drinks', label: 'Meals & Drinks' },
    { value: 'home_hardware', label: 'Home Hardware' },
    { value: 'cannabis', label: 'Cannabis Distribution' },
    { value: 'other', label: 'Other' },
  ];
}

export function getDeliveryTiers() {
  return [
    { value: 'tier_1', label: '< 300' },
    { value: 'tier_2', label: '300 - 999' },
    { value: 'tier_3', label: '1,000 - 4,999' },
    { value: 'tier_4', label: '5,000 - 9,999' },
    { value: 'tier_5', label: '10,000 - 24,999' },
    { value: 'tier_6', label: '25,000 - 49,999' },
    { value: 'tier_7', label: '50,000 - 99,999' },
    { value: 'tier_8', label: '100,000 +' },
  ];
}

export function getCountries() {
  return [
    { value: 'US', label: 'United States' },
    { value: 'CA', label: 'Canada' },
    { value: 'MX', label: 'Mexico' },
    { value: 'AL', label: 'Albania' },
    { value: 'AU', label: 'Australia' },
    { value: 'AT', label: 'Austria' },
    { value: 'BR', label: 'Brazil' },
    { value: 'BE', label: 'Belgium' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'CL', label: 'Chile' },
    { value: 'CO', label: 'Colombia' },
    { value: 'HR', label: 'Croatia' },
    { value: 'CY', label: 'Cyprus' },
    { value: 'CZ', label: 'Czech Republic' },
    { value: 'CD', label: 'Democratic Republic of the Congo' },
    { value: 'DK', label: 'Denmark' },
    { value: 'EE', label: 'Estonia' },
    { value: 'FI', label: 'Finland' },
    { value: 'FR', label: 'France' },
    { value: 'DE', label: 'Germany' },
    { value: 'GR', label: 'Greece' },
    { value: 'HU', label: 'Hungary' },
    { value: 'IE', label: 'Ireland' },
    { value: 'IT', label: 'Italy' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'LV', label: 'Latvia' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'MT', label: 'Malta' },
    { value: 'NL', label: 'Netherlands' },
    { value: 'PL', label: 'Poland' },
    { value: 'PT', label: 'Portugal' },
    { value: 'OM', label: 'Oman' },
    { value: 'QA', label: 'Qatar' },
    { value: 'CG', label: 'Republic of the Congo' },
    { value: 'RO', label: 'Romania' },
    { value: 'SK', label: 'Slovakia' },
    { value: 'SI', label: 'Slovenia' },
    { value: 'ES', label: 'Spain' },
    { value: 'SA', label: 'Saudi Arabia' },
    { value: 'SE', label: 'Sweden' },
    { value: 'TR', label: 'Turkey' },
    { value: 'AE', label: 'United Arab Emirates' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'ZW', label: 'Zimbabwe' },
  ];
}
